<template>
  <section :class="$options.name" v-scroll="handleScroll">
    <section
      v-if="images"
      :class="[
      $options.name + '__image',
      images.length > 1 ? $options.name + '__image--multi':''
    ]"
    >
      <Img v-for="(image,index) in images" :key="index" :alt="'Image of ' + title" :src="image.fields.file.url + '?fm=jpg&fl=progressive&w=720'"/>
    </section>
    <section :class="$options.name + '__content'">
      <section class="Box">
        <header :class="$options.name + '__content--header'">
          <h3 v-if="title">{{ title }}</h3>
          <h4 v-if="subtitle">{{ subtitle }}</h4>
          <section v-if="email || phone" :class="$options.name + '__content--contact'">
            <p v-if="email">
              <strong>Email:&nbsp;</strong>
              <a :href="'mailto:' + email">{{ email }}</a>
            </p>
            <p v-if="phone">
              <strong>Phone:&nbsp;</strong>
              {{ phone }}
            </p>
          </section>
        </header>
        <RichText
          v-if="description"
          :class="$options.name + '__content--body'"
          tag="figcaption"
          :value="description"
        />
      </section>
    </section>
  </section>
</template>
<script>
import Img from "@/components/Img";
import RichText from "@/components/RichText";
export default {
  name: "CrewMember",
  components: { Img, RichText },
  methods: {
    handleScroll(evt, el) {
      let position = el.getBoundingClientRect();
      let top = position.top;
      if (window.scrollY > top) {
        el.classList.add("scrolled");
      }
    }
  },
  props: {
    description: { default: null },
    email: { default: null },
    images: { default: null },
    phone: { default: null },
    subtitle: { default: null },
    title: { default: "Member Title" }
  }
};
</script>
<style lang="scss">
.CrewMember {
  @include smooth;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  padding: rem(16) 0;
  transform: translateY(rem(-32));
  &.scrolled {
    transform: translateY(0);
  }
  &__image {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    margin-bottom: rem(16);
    width: 100%;
    @include breakpoint(l) {
      flex-basis: calc(50% - 4rem);
      justify-content: flex-end;
      max-width: 50%;
      padding: 0 rem(32);
    }
    figure {
      border-radius: rem(4);
      box-shadow: 0 rem(16) rem(32) rem(-16) rgba(black, 0.25);
      overflow: hidden;
    }
  }
  &__content {
    flex: 1 1 50%;
    width: 100%;
    @include breakpoint(l) {
      max-width: 50%;
    }
    .Box {
      max-width: rem(960);
    }
    &--header {
      h4 {
        color: var(--base-mid);
        margin-top: rem(8);
      }
    }
    &--contact {
      align-items: center;
      border-top: rem(1) solid var(--base-light);
      display: flex;
      flex-wrap: wrap;
      margin-top: rem(16);
      padding: rem(16) 0;
      > * {
        flex: 1 0 50%;
      }
    }
    &--body {
      border-top: rem(1) solid var(--base-light);
      margin-top: 0;
      padding-top: rem(16);
      > * + * {
        margin-top: rem(16);
      }
    }
  }
}
</style>